<template>
  <div class="about-page">
    <headerView :seletedindex="seletedindex" /><!-- 顶部横幅 -->
    <div
      class="banner"
      :style="{
        backgroundImage:
          'url(' +
          aboutUsBanner.imgUrl +
          ')',
      }"
    >
    </div>
    <div class="new_details_content">
      <div class="container" v-html="AboutUsContent"></div>
    </div>
    <footerView />
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, aboutUsContent } from "@/api/index";

export default {
  name: "AboutUs",
  components: {
    headerView,
    footerView
  },
  data() {
    return {
      aboutUsBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      seletedindex: 1,
      AboutUsContent: ""
    };
  },
  created() {
    this.$nextTick(() => {
      this.getaboutUsBanner();
      this.getCoreTeamList();
    });
  },
  methods: {
    async getCoreTeamList() {
      const res = await aboutUsContent("/api/zaoying/aboutUsContent");
      if (res.length > 0) {
        this.AboutUsContent = res[0].content;
      }
    },
    async getaboutUsBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 13 });
      if (res.length > 0) {
        this.aboutUsBanner = res[0];
      }
    }
  }
};
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background-color: #fff;
}

.banner {
  background-size: cover;
  background-position: center;
  min-height: 25vw;
  height: 25vw;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner h1 {
  font-size: 42px;
  margin-bottom: 25px;
  font-weight: 500;
}

.banner p {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}
.new_details_content {
  max-width: 1200px;
  margin: 30px auto 30px auto;
  line-height: 58px;
  padding: 0 20px;
  box-sizing: border-box;
}
.container {
  margin: 20px auto;
  background-color: #fff;
}

.container :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 15px auto;
}

.container :deep(p img) {
  margin: 15px 0;
  float: left;
  margin-right: 20px;
  margin-bottom: 15px;
}

.container :deep(p) {
  text-align: justify;
  overflow: hidden;
}

.container :deep(p:has(img:only-child)) {
  text-align: center;
}

.container :deep(p:has(img:only-child) img) {
  float: none;
  margin: 15px auto;
}

.container :deep(video) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 15px auto;
}

.container :deep(p video) {
  margin: 15px 0;
  float: left;
  margin-right: 20px;
  margin-bottom: 15px;
}

.container :deep(p:has(video:only-child)) {
  text-align: center;
}

.container :deep(p:has(video:only-child) video) {
  float: none;
  margin: 15px auto;
}

.container :deep(iframe) {
  max-width: 100%;
  display: block;
  margin: 15px auto;
}

.container :deep(p iframe) {
  margin: 15px 0;
  float: left;
  margin-right: 20px;
  margin-bottom: 15px;
}

.container :deep(p:has(iframe:only-child)) {
  text-align: center;
}

.container :deep(p:has(iframe:only-child) iframe) {
  float: none;
  margin: 15px auto;
}
/* 我们的故事部分 */
.story-section {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.story-content {
  display: flex;
  gap: 60px;
  align-items: center;
}

.story-image {
  flex: 1;
}

.story-image img {
  width: 100%;
  border-radius: 8px;
}

.story-text {
  flex: 1;
}

.story-text h2 {
  font-size: 32px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
}

.story-text p {
  color: #666;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2rem;
}

/* 企业价值观部分 */
.values-section {
  padding: 80px 20px;
  background: #f5f7fa;
}

.values-section h2 {
  font-size: 32px;
  color: #333;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 500;
}

.values-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.value-card {
  background: white;
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  flex: 1;
}

.value-card .icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}

.value-card i {
  font-size: 36px;
  color: #1890ff;
}

.value-card h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 500;
}

.value-card p {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}

/* 核心团队部分 */
.team-section {
  padding: 80px 20px;
  max-width: 80vm;
  margin: 0 auto;
}

.team-section_div1 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  justify-content: center;
}

.team-section_div1:hover .btn {
  display: block;
}

.team-section h2 {
  font-size: 32px;
  color: #333;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 500;
}

.team-grid {
  width: 1200px;
  /* display: grid;
  grid-auto-flow: column; */
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  /* gap: 30px; */
}

.team-grid-item {
  display: flex;
  transform: all 2s;
  position: relative;
  left: 0;
  transition: left 1s;
}

.team-card {
  width: 100%;
}

.member-image {
  width: 200px;
  height: 200px;
  margin: 0 50px;
  border-radius: 50%;
  overflow: hidden;
}

.member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.team-card h3 {
  font-size: 18px;
  color: #333;
  margin: 10px auto;
  font-weight: 500;
  text-align: center;
}

.team-card .position {
  width: 300px;
  margin: 0px auto;
  color: #1890ff;
  font-size: 14px;
  margin-bottom: 15px;
}

.team-card .description {
  width: 300px;
  margin: 0px auto;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* 数据统计部分 */
.stats-section {
  padding: 60px 0px;
  background: #1890ff;
  display: flex;
  justify-content: center;
  gap: 120px;
  width: 100%;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
}

.stat-item {
  text-align: center;
  color: white;
}

.stat-number {
  font-size: 48px;
  font-weight: 500;
  margin-bottom: 10px;
}

.stat-number span {
  font-size: 32px;
}

.stat-label {
  font-size: 18px;
  margin-bottom: 5px;
}

.stat-desc {
  font-size: 14px;
  opacity: 0.8;
}

/* 办公地点部分 */
.office-section {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.office-section h2 {
  font-size: 32px;
  color: #333;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 500;
}

.office-locations {
  display: flex;
  gap: 30px;
  justify-content: center;
}

.office-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  flex: 1;
  max-width: 400px;
}

.office-card h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 500;
}

.office-card p {
  color: #666;
  font-size: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.office-card i {
  color: #1890ff;
  margin-right: 10px;
  font-size: 18px;
}

/* 响应式布局 */
@media (max-width: 1024px) {
  .story-content {
    flex-direction: column;
  }

  .values-grid {
    flex-direction: column;
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .stats-section {
    flex-wrap: wrap;
    gap: 80px;
  }

  .stat-item {
    flex: 1;
    min-width: 200px;
  }

  .office-locations {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 768px) {
  .team-grid {
    grid-template-columns: 1fr;
  }

  .banner {
    height: 50vw;
  }

  .stats-section {
    padding: 40px 0px;
  }

  .stat-item {
    width: 100%;
  }
}
.btn {
  border: 1px solid #b3d8ff;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  background-color: #ecf5ff;
  font-size: 24px;
  color: #409eff;
  margin: 0px 50px;
  border-radius: 50%;
  display: none;
}

.btn:hover {
  background-color: #409eff;
  color: white;
}
</style>